import React, { useState } from 'react';
import { useAIContext } from "store/contexts/aiContext";
import GeneralService from 'services/GeneralService';
import CustomButton from 'components/CustomButton';
import Loader from 'components/Loader';
import { useTeamContext } from "store/contexts/teamContext";

function GenerateCaptions() {
	const { sendToS3, formik, aiOption } = useAIContext();
	const { attachment, text } = formik.values;
	const [progressBar, setUploadProgress] = useState(0);
	const [loading, setLoading] = useState(false);
	const { team } = useTeamContext();

	const generateCaptions = async () => {
		setLoading(true);
		let media = null;
		media = await sendToS3(attachment, setUploadProgress);
		var subtitleResponse = await GeneralService.generateTranscription({
			team_id: team.id,
			media: media
		});

		formik.setFieldValue("text", subtitleResponse.data.data.content);
		setUploadProgress(`${100}%`);
		formik.setFieldValue("attachment", null);
		setLoading(false);
	}

	return (
		<>
			{aiOption && !text && (
				<div className='captionButtonRoot'>
					<CustomButton onClick={generateCaptions} buttonClass="captionButton" disabled={loading} type="button">{!loading ? "Generate Caption" : <div style={{ display: 'flex', width: '100%', justifyContent: 'center', textAlign: 'center', gap: "10px" }}>{progressBar} <Loader width={15} height={15} /></div>}</CustomButton>
				</div>
			)}
		</>)
}

export default GenerateCaptions